import css from './ClientOverview.module.css'
import pushupsImage from '../../../assets/pushups.jpg'
import equipmentImage from '../../../assets/equipment.jpg'
import paymentsImage from '../../../assets/payments.jpg'
import sessionsImage from '../../../assets/sessions.png'
import subscriptionsImage from '../../../assets/subscriptions.png'

import {
	useFinancialsDashboardTabs,
	usePurchaseAvailabilites
} from '../hooks'

export default function ClientOverview(){
	const {activeTab,setActiveTab} = useFinancialsDashboardTabs()
	const {status,availabilities} = usePurchaseAvailabilites()
	const cards = [
		{
			title:'Packages',
			key:'packages',
			text:"Personal training sessions in bulk",
			img:pushupsImage,
			hide:!availabilities.packages
		},{
			title:'Sessions',
			text:'Purchase personal training sessions',
			key:'sessions',
			img:sessionsImage,
			hide:!availabilities.sessions
		},{
			title:'Custom Payment',
			text:'Pay your trainer a custom amount',
			key:'customPayment',
			img:paymentsImage,
			hide:!availabilities.custom_payment
		},{
			title:'Subscriptions',
			text:'Recurring training services',
			key:'subscriptions',
			img:subscriptionsImage,
			hide:!availabilities.subscriptions
		},{
			title:'Products',
			text:'Equipment and merchandise',
			key:'myProducts',
			img:equipmentImage,
			hide:!availabilities.merchandise
		}
	]
	return (
		<div style={{height:'100%',overflow:'auto'}}>
			<div className="text-center p-3">
				<strong>Purchase goods and services offered by your trainer</strong>
			</div>
			<div className={css.Grid}>
				{cards.filter(({hide})=>!hide).map(card=>(
					<div 
						onClick={setActiveTab.bind(null,card.key)}
						className={css.Card} 
						key={card.key}
					>
						<img 
							src={card.img}
							style={{
								width:'100%',
								height:'300px',
								background:'#ccc',
								display:'flex',
								alignItems:'center',
								justifyContent:'center',
								objectFit:'cover'
							}}
						/>
						<strong style={{
							position:'absolute',
							display:'flex',
							padding:'4px 18px',
							color:'#fff',
							background:'rgba(0,0,0,0.7)',
							borderRadius:'0 0 7px 0',
							top:0,left:0
						}}>
							{card.title}
						</strong>
						<div style={{
							position:'absolute',
							display:'flex',
							padding:'4px 18px',
							width:'100%',
							color:'#fff',
							background:'rgba(0,0,0,0.7)',
							bottom:0,left:0
						}}>
							{card.text}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}